import React from 'react';
import RoleManagementFunctional from './components/role-management-functional';

const RoleManagement = () => {
	return <RoleManagementFunctional />;
};

export default RoleManagement;
